// src/pages/LoginPage.js

import React, { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { FiMail, FiLock } from "react-icons/fi";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setIsLoading(true);

    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      setError(
        err.response?.data?.message ||
        err.message ||
        "Não foi possível realizar o login."
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center p-6"
      style={{
        background:
          "radial-gradient(circle at top, #0f172a, #020617)",
      }}
    >
      {/* MAIN CARD */}
      <div
        className="animate-fadeIn w-full max-w-4xl grid md:grid-cols-2
                   bg-white/10 backdrop-blur-xl shadow-2xl rounded-2xl
                   overflow-hidden border border-white/20"
      >

        {/* LEFT — SIDE HERO */}
        <div
          className="hidden md:flex flex-col justify-center p-10 text-white"
          style={{
            background:
              "linear-gradient(135deg, #4f46e5, #7c3aed)",
          }}
        >
          <h1 className="text-4xl font-extrabold leading-tight bandEs-white/40">
            Bem-vindo de volta!
          </h1>

          <p className="mt-4 text-lg opacity-90">
            Continue sua jornada de aprendizado acessando sua conta.
          </p>

          <div className="mt-8 flex items-center gap-3 text-sm opacity-90">
            <span className="w-3 h-3 rounded-full bg-green-400"></span>
            Acesso rápido e seguro
          </div>

          <div className="mt-2 flex items-center gap-3 text-sm opacity-90">
            <span className="w-3 h-3 rounded-full bg-blue-300"></span>
            Plataforma moderna e estável
          </div>
        </div>

        {/* RIGHT — LOGIN FORM */}
        <div className="p-10">
          <h2 className="text-3xl font-bold text-center mb-8 text-white/40">
            Entrar na Plataforma
          </h2>

          {/* ERROR */}
          {error && (
            <div
              className="px-4 py-3 mb-5 rounded-lg text-center
                         bg-red-500/20 border border-red-400
                         text-red-300"
            >
              {error}
            </div>
          )}

          {/* FORM */}
          <form onSubmit={handleSubmit} className="auth-form">

            {/* EMAIL */}
            <div className="input-group">
              <FiMail className="input-icon" />
              <input
                type="email"
                placeholder="Seu e-mail"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={isLoading}
              />
            </div>

            {/* PASSWORD */}
            <div className="input-group">
              <FiLock className="input-icon" />
              <input
                type="password"
                placeholder="Sua senha"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                disabled={isLoading}
              />
            </div>

            {/* BUTTON */}
            <button
              type="submit"
              disabled={isLoading}
              className="w-full py-3 mt-4 rounded-xl font-bold text-lg
                         text-white transition-all
                         bg-gradient-to-r from-indigo-500 to-purple-600
                         hover:shadow-lg hover:scale-[1.01]
                         disabled:opacity-50 disabled:cursor-wait"
            >
              {isLoading ? "Entrando..." : "Entrar"}
            </button>
          </form>

          {/* REGISTER */}
          <p className="mt-6 text-center text-sm opacity-80">
            Ainda não possui conta?{" "}
            <Link
              to="/cadastro"
              className="font-semibold text-indigo-400 hover:underline"
            >
              Cadastre-se aqui
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
